<p>Are you sure?</p>

<div class="actions m-t--20">
  <button type="button" class="btn btn-outline-primary m-t-20" (click)="cancel()">{{ 'generic.cancel' | cxTranslate }}</button>

  <button type="button" class="btn btn-primary m-t-20" (click)="confirm()">{{ 'generic.confirm' | cxTranslate }}</button>
</div>
